import script from "./ComTilat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComTilat.vue?vue&type=script&setup=true&lang=ts"

import "./ComTilat.vue?vue&type=style&index=0&id=8e4faa58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e4faa58"]])

export default __exports__